import $ from 'jquery';

const namespace = 'sorter';

export default class Sorter {
  constructor(el, options) {
    this.options = $.extend(
      true,
      {
        isControlled: false,
      },
      options,
    );
    this.$el = $(el);
    this.bind();
  }

  bind() {
    this.$el.on(`change.${namespace}`, this.handleChange.bind(this));
  }

  unbind() {
    this.$el.off(`change.${namespace}`);
  }

  /**
   * @returns {URLSearchParams}
   */
  getSearchParams() {
    const params = new window.URLSearchParams(window.location.search);
    params.sort();
    return params;
  }

  /**
   * @param {String} value
   */
  setOption(value) {
    this.$el.val(value);
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    const searchParams = this.getSearchParams();
    const {target} = event;

    if (target.value) {
      searchParams.set(target.name, target.value);
    } else {
      searchParams.delete(target.name);
    }

    searchParams.delete('page');

    if (this.options.isControlled) {
      const params = new window.URLSearchParams(`?sort_by=${target.value}`);
      params.sort();

      this.$el.trigger(`${namespace}:changed`, {
        params,
      });

      return;
    }

    window.location = `?${searchParams}`;
  }
}
